import { __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
const Textfield = React.forwardRef((_a, ref) => {
    var { iconBefore, iconAfter, invalid, className, addonBefore, addonAfter, onFocus, onBlur, id } = _a, props = __rest(_a, ["iconBefore", "iconAfter", "invalid", "className", "addonBefore", "addonAfter", "onFocus", "onBlur", "id"]);
    const [focused, setFocused] = React.useState(false);
    const handleFocus = (e) => {
        setFocused(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
    };
    const handleBlur = (e) => {
        setFocused(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    };
    const cmpName = 'textfield';
    const addonClassName = `${cmpName}__addon`;
    const iconClassName = `${cmpName}__icon`;
    const addonBeforeNode = addonBefore ? (React.createElement("span", { className: addonClassName }, addonBefore)) : null;
    const addonAfterNode = addonAfter ? (React.createElement("span", { className: addonClassName }, addonAfter)) : null;
    const iconBeforeNode = iconBefore ? (React.createElement("span", { className: iconClassName }, iconBefore)) : null;
    const iconAfterNode = iconAfter ? (React.createElement("span", { className: iconClassName }, iconAfter)) : null;
    return (React.createElement("div", { id: id, className: clsx(cmpName, {
            [`${cmpName}--icon-before`]: !!iconBefore,
            [`${cmpName}--icon-after`]: !!iconAfter,
            [`${cmpName}--invalid`]: invalid,
            [`${cmpName}-addons`]: !!(addonBefore || addonAfter),
            [`${cmpName}--focused`]: focused,
            [`${cmpName}--disabled`]: props.disabled,
        }, className) },
        addonBeforeNode,
        React.createElement("div", { className: clsx(`${cmpName}__input`) },
            iconBeforeNode,
            React.createElement("input", Object.assign({}, props, { onFocus: handleFocus, onBlur: handleBlur, ref: ref })),
            iconAfterNode),
        addonAfterNode));
});
Textfield.displayName = 'Textfield';
export { Textfield };
//# sourceMappingURL=Textfield.js.map